import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    minRequestedQuantity: {
      id: 'pages.settings.sections.general.settings.minRequestedQuantity',
      defaultMessage: 'Minimum item quantity',
      description: 'Title of the minimum requested quantity setting',
    },
    atLeastOneProductManually: {
      id: 'pages.settings.sections.general.settings.atLeastOneProductManually',
      defaultMessage: 'Handle at least one product manually',
      description: 'Title of the at least one product manually setting',
    },
  },
};

export default defineMessages(translations);
